import { Box, TextField } from "@mui/material";
import React from "react";
import Grid from "@mui/material/Grid";
import FormControl from "@mui/material/FormControl";
import Banner from "../Banner/Banner";
import { LAT_LON_DECIMAL_TITLE } from "../../constants/LatLong";

export default function DecimalDegrees(props) {
  return (
    <Box mt={0} width="100%" align="center">
      <Banner title={LAT_LON_DECIMAL_TITLE} />
      <h2 className="sectionTitle center">Decimal Degrees</h2>
      <p>Minimum of 4 decimal places required</p>
      <Grid container justifyContent="center" alignItems="center" spacing={2}>
        <Grid item xs={12} md="auto">
          <FormControl>
            <TextField
              variant="standard"
              inputProps={{
                style: { textAlign: "center" },
              }}
              label="Latitude:"
              className="number-of-input"
              value={
                props.latitude_or_loran1.decimal_degrees
                  ? props.latitude_or_loran1.decimal_degrees
                  : ""
              }
              name="dec_degrees_latitude"
              type="number"
              onChange={(e) => props.handleLatChange(e)}
              helperText="(e.g.: 42.1545)"
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} md="auto">
          <FormControl>
            <TextField
              variant="standard"
              inputProps={{
                style: { textAlign: "center" },
              }}
              label="Longitude:"
              className="number-of-input"
              value={
                props.longitude_or_loran2.decimal_degrees
                  ? props.longitude_or_loran2.decimal_degrees
                  : ""
              }
              name="dec_degrees_longitude"
              type="number"
              onChange={(e) => props.handleLonChange(e)}
              helperText="(e.g.: 71.3545)"
            />
          </FormControl>
        </Grid>
      </Grid>
    </Box>
  );
}
